import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useReorderHomePortfolios = () => {
  const mutation = trpc.portfolioManagement.items.reorderHome.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, reorderHome: action.execute };
};
